// This file was AUTO-GENERATED by the Typewriter Visual Studio plugin base on the HandlerModels.tst template. 
// !!Do not modify this file or change may be lost!!
// GetActionPlanReportDataHandler
/* eslint-disable */
// @ts-ignore
import * as moment from 'moment';
import ActionPlanReportDTO from '../models/ActionPlanReportDTO';
import ResultDTO from '../models/ResultDTO';

interface Request {
    academicYearId: number;
}

const Request = {
    create: (initValues?: Partial<Request> | Record<string, unknown> | null) => {
        return Object.assign(
        {
            academicYearId: 0,
        },
        initValues);
    },
    academicYearId: 'academicYearId',
}

interface Result extends ResultDTO {
    dataRows: ActionPlanReportDTO[] | null;
}

const Result = {
    create: (initValues?: Partial<Result> | Record<string, unknown> | null) => {
        return Object.assign(ResultDTO.create(),
        {
            dataRows: [],
        },
        initValues);
    },
    dataRows: 'dataRows',
}

export { Request, Result };